<template>
  <div>
    <div class="home-banners-box carousel slide" data-ride="carousel" id="hpStripBannerCarousel" role="region">
      <div class="carousel-inner" v-if="images.stripBanners.length > 0">
        <div class="item" v-for="(banner, index) in images.stripBanners" :key="index" :class="[index === 0 ? activeClass: '']">
          <img :src="banner">
        </div>
      </div>
      <div class="carousel-inner" v-else>
        <div class="item" v-for="(preview, index) in component.previews" :key="preview.index" :class="[index === 0 ? activeClass: '']">
          <img :src="preview.image">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ['component', 'images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand,
      activeClass: 'active'
    };
  },
  computed: {
    ...mapGetters(["chosenArray"]),
  },
  mounted() {
    (function() {
      
      var c = {
        init: function() {
          $('#hpStripBannerCarousel').carousel({
            interval: 5000
            })
        }
      }
      $(document).ready(c.init);
    })(jQuery);
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  .home-banners-box {
    cursor: pointer;
  }
  #hpStripBannerCarousel, #hpStripBannerCarousel .item img, #hpStripBannerCarousel .item {
    width: 100%;
  }
</style>
